import { lazy } from 'react';

import Loadable from 'components/Loadable';
import RequireAuth from './RequireAuth';

const EventTablesPrintPage = Loadable(lazy(() => import('pages/events/tables-print')));

const PrintRoutes = {
  path: '/',
  children: [
    {
      path: '/events/:eventId/tables/print',
      element: (
        <RequireAuth>
          <EventTablesPrintPage />
        </RequireAuth>
      )
    }
  ]
};

export default PrintRoutes;
